import { DL_EVENT, BOTS } from '../analytics/constants';

declare global {
  interface Window {
    gaGlobal: Record<string, unknown>; // {} object
    Intercom: (...args: unknown[]) => void; // functions w. spread syntax because args may vary

    dataLayer: unknown[];  // [] object
    _hsq: unknown[];

    analytics: {
      ready: (...args: unknown[]) => void;
      track: (...args: unknown[]) => void;
    }; // {} object w. several .methods() (= functions)
  }
}

export const isBot = () => BOTS.some(i => window.navigator.userAgent?.toLowerCase()?.includes(i));


export const appendScript = (
  src: string, 
  props: Record<string, unknown> = {}, // optional bc {} fallback value provided
  callback?: (...args: unknown[]) => void // ?: = optional
) => {
  const script = document.createElement('script');
  /^(http|\/\/)/.test(src) ? script.src = src : script.innerHTML = src;
  Object.keys(props).map(k => script.setAttribute(k, props[k] as string));
  document.head.appendChild(script);
  if (callback) script.onload = callback;
};


export const obscureString = (str: string) => {
  if (!str) return undefined;
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const getRandomChar = () => chars[Math.floor(Math.random() * chars.length)];
  const swapChar = (str: string) => (/^[^\w]+$/i.test(str) ? str : getRandomChar());
  const applySwap = (str: string) => str.split('').map(i => (i = swapChar(i))).join('');

  const isEmail = /^[^@]*@[^.@]*\.[A-Za-z0-9.]+$/i.test(str);
  if (isEmail) {
    const parts = str.split('@');
    const obscuredUsername = applySwap(parts[0]);
    const obscuredDomain = parts[1].split('.').map(i => applySwap(i)).join('.');
    return `${obscuredUsername}@${obscuredDomain}`;
  } else {
    return applySwap(str);
  }
};


 /*
  . sGTM DL push - V2, payload structure is important
  . leadUserData is sent using Google object format / field names
  . formLabel and adSpend (if any) are sent as custom event attributes
  . GA4 auto captures 'page_location' (is used for element_click event settings in GA4)
*/
export const customDataLayerPush = (event: string, props: Record<string, unknown>) => {
  window?.dataLayer.push({event: event, ...props});
};


export const loadYoutubePlayer = (id: string) => {
  const settings = { videoId: id, width: '100%', height: '100%'};
  const playerVars = {playsinline: 1, origin: window.location.host};
  // const playerEvents = {onReady: percentWatched, onStateChange: playerState};

  const youtube = window['YT' as keyof typeof window];
  new youtube.Player('yt-player', {playerVars: playerVars, ...settings});
};


/*
pass URL params between domain and subdomain
JSON.parse(document.cookie.match(`(^|;)\\s*${MARKETING_COOKIE}\\s*=\\s*([^;]+)`)?.pop() || '{}');
*/
export const appendUrlParams = (url: string) => {
  const props = { ...window?.localStorage };
  const params = Object.keys(props).filter(i => /fbclid|li_fat_id|gclid|utm_/.test(i));
  const append = params.map((i: string) => `${i}=${props[i]}`).join('&');
  return append ? url + (url.includes('?') ? '&' : '?') + append : url;
};
